export const songFields = [
	{ name: 'id', text: 'No.', style: 'width: 4em' },
	{ name: 'title', text: 'Title', style: 'min-width: 12em' },
	{ name: 'artist', text: 'Artist', style: 'min-width: 12em' },
	{ name: 'theme', text: 'Theme', style: 'min-width: 6em' },
	{ name: 'alpha', text: 'Alpha', style: 'width: 3.8em' },
	{ name: 'beta', text: 'Beta', style: 'width: 3.8em' },
	{ name: 'delta', text: 'Delta', style: 'width: 3.8em' },
	{ name: 'duration', text: 'Time' },
	{ name: 'created_at', text: 'Date Added' },
	{ name: 'action', text: 'Actions' }
]

export const subscriptionFields = [
	{ name: 'id', text: 'No.', style: 'width: 8em;' },
	{ name: 'name', text: 'Name' },
	{ name: 'price', text: 'Price' },
	{ name: 'currency', text: 'Currency' },
	{ name: 'duration', text: 'Duration' },
	{ name: 'billing_cycle', text: 'Billing Cycle' },
	{ name: 'created_at', text: 'Date Added' },
	{ name: 'action', text: 'Actions' }
]

export const bindingAccountFields = [
	{ name: 'id', text: 'No.', style: 'width: 8em;' },
	{ name: 'name', text: 'Name', style: 'min-width: 16em;' },
	{ name: 'email', text: 'Email Address' },
	{ name: 'date_bind', text: 'Date Bind', style: 'width: 12em;' },
	{ name: 'plan_name', text: 'Subscription Plan' },
	{ name: 'subscription_end', text: 'Subscription End', style: 'width: 12em;' }
]

export const subscriberPlansFields = [
	{ name: 'name', text: 'Subscription Plan', style: 'width: 20em;' },
	{ name: 'price', text: 'Price', style: 'width: 12em;' },
	{ name: 'billing_cycle', text: 'Billing Type', style: 'text-transform: capitalize' },
	{ name: 'duration', text: 'Days' },
	{ name: 'subscription_discount', text: 'Discounted' },
	{ name: 'discount', text: 'Discount Price' },
	{ name: 'discount_duration_to', text: 'Discount Expiration' },
	{ name: 'action', text: 'Actions' }
]

export const rawThemeFormState = {
	form: {
		name: '',
		description: '',
		image: {
			server_name: '',
			value: null
		}
	}
}

export const themeItems = [
	'Meditation',
	'Yoga',
	'Fitness',
	'Casual Chill',
	'Party',
	'Working',
	'Gaming',
	'Road Trip',
	'Dining',
	'Sleep',
	'Creating'
]

export const rawMusicErrors = {
	title: '',
	artist: '',
	theme: '',
	classification: '',
	music: ''
}
export const rawThemeErrors = {
	name: '',
	description: '',
	image: ''
}
export const rawSubscriptionPlanError = {
	name: '',
	price: '',
	billing_cycle: '',
	duration: '',
	is_discounted: ''
}

export const themeFields = [
	{ name: 'id', text: 'ID', style: 'width: 6em;' },
	{ name: 'image', text: 'Image', style: 'width: 8em;' },
	{ name: 'name', text: 'Name', style: 'width: 8em;' },
	{ name: 'description', text: 'Description' },
	{ name: 'created_at', text: 'Date Created' },
	{ name: 'action', text: 'Actions', style: 'width: 8em;' }
]

export const sortItems = [
	'Latest',
	'Oldest'
]

export const rawSubscriptionPlanForm = {
	name: '',
	price: '',
	billing_cycle: '',
	duration: '',
	is_discounted: 0,
	discount: '',
	currency: 'usd',
	discount_duration_to: null,
	discount_duration_from: null
}
